import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { MdClose } from "react-icons/md";
import styles from "./Label.module.scss";
export default function Label(_a) {
    var { children, onClose } = _a, props = __rest(_a, ["children", "onClose"]);
    return (_jsxs("div", Object.assign({}, props, { className: clsx(styles.label, props.className), children: [_jsx("div", { className: styles.children, children: children }), onClose && _jsx(MdClose, { className: styles.close, onClick: onClose })] })));
}
